export default {
  createItem: "PubSubTopics:CREATE_ITEM",
  createMarker: "PubSubTopics:CREATE_MARKER",
  scrollToItem: "PubSubTopics:SCROLL_TO_ITEM",
  scrollToCell: "PubSubTopics:SCROLL_TO_CELL",
  scrollToDate: "PubSubTopics:SCROLL_TO_DATE",
  scrollToDualDate: "PubSubTopics:SCROLL_TO_DUAL_DATE",
  dragStarted: "PubSubTopics:DRAG_STARTED",
  dragEnded: "PubSubTopics:DRAG_ENDED",
  dragAutoscroll: "PubSubTopics:DRAG_AUTOSCROLL",
  externalActionReceived: "PubSubTopics:EXTERNAL_ACTION_RECEIVED",
  sendNativeMessage: "PubSubTopics:SEND_NATIVE_MESSAGE",
  welcomeActionReceived: "PubSubTopics:WELCOME_ACTION_RECEIVED",
  welcomeScreenHidden: "PubSubTopics:WELCOME_SCREEN_HIDDEN",
  pulseAnimationEnd: "PubSubTopics:PULSE_ANIMATION_END",
  selectItemByTopics: "PubSubTopics:SELECT_ITEM_BY_TOPICS",
  selectAllItems: "PubSubTopics: SELECT_ALL_ITEMS",
  selectFirstItem: "PubSubTopics:SELECT_FIRST_ITEM",
  selectPreviousItem: "PubSubTopics:SELECT_PREVIOUS_ITEM",
  selectNextItem: "PubSubTopics:SELECT_NEXT_ITEM",
  selectLastItem: "PubSubTopics:SELECT_LAST_ITEM",
  selectAllBeforeCurrentItem: "PubSubTopics:SELECT_ALL_BEFORE_CURRENT_ITEM",
  selectAllAfterCurrentItem: "PubSubTopics:SELECT_ALL_AFTER_CURRENT_ITEM",
  syncSettingsBrowseResult: "PubSubTopics:SYNC_SETTINGS_BROWSE_RESULT",
  printWithLoadedImages: "PubSubTopics:PRINT_WITH_LOADED_IMAGES",

  ulyssesAuthorizationRequested: "PubSubTopics:ULYSSES_AUTHORIZATION_REQUESTED",
  ulyssesAuthorizationReceived: "PubSubTopics:ULYSSES_AUTHORIZATION_RECEIVED",

  syncSettingsUlyssesTreeResult: "PubSubTopics:ULYSSES_TREE_RESULT",

  // licenseStatusUpdate: "PubSubTopics:LICENSE_STATUS_UPDATE",

  syncSettingsDataReceived: "PubSubTopics:SYNC_SETTINGS_DATA_RECEIVED",
  syncUpdateResult: "PubSubTopics:SYNC_UPDATE_RESULT",

  alertPromptResult: "PubSubTopics:ALERT_PROMPT_RESULT",
  okCancelPromptResult: "PubSubTopics:OK_CANCEL_PROMPT_RESULT",
  yesNoPromptResult: "PubSubTopics:YES_NO_PROMPT_RESULT",
  yesNoCancelPromptResult: "PubSubTopics:YES_NO_CANCEL_PROMPT_RESULT",

  printPdfGenerated: "PubSubTopics:printPdfGenerated",

  clipboardEventPending: "PubSubTopics:clipboardEventPending",
  cut: "PubSubTopics:cut",
  copy: "PubSubTopics:copy",
  paste: "PubSubTopics:paste",
  inlineEditingEnded: "PubSubTopics:INLINE_EDITING_ENDED",

  backupDataReceived: "PubSubTopics:BACKUP_DATA_RECEIVED",

  importCsvDataReceived: "PubSubTpics:IMPORT_CSV_DATA_RECEIVED",
  importCsvModalReady: "PubSubTpics:IMPORT_CSV_MODAL_READY",

  customTemplateIndexReceived: "PubSubTopics:CUSTOM_TEMPLATE_INDEX_RECEIVED",
  customTemplateDataReceived: "PubSubTopics:CUSTOM_TEMPLATE_DATA_RECEIVED",
  customTemplateDeleted: "PubSubTopics:CUSTOM_TEMPLATE_DELETED",

  ctrlModifierKeyDown: "PubSubTopics:CONTROL_MODIFIER_KEY_DOWN",
  ctrlModifierKeyUp: "PubSubTopics:CONTROL_MODIFIER_KEY_UP",
  altModifierKeyDown: "PubSubTopics:ALTERNATIVE_MODIFIER_KEY_DOWN",
  altModifierKeyUp: "PubSubTopics:ALTERNATIVE_MODIFIER_KEY_UP",
  escapeKeyDown: "PubSubTopics:ESCAPE_KEY_DOWN",
  undoText: "PubSubTopics:UNDO_TEXT",
  redoText: "PubSubTopics:REDO_TEXT",

  // retrieving website data
  websiteUpdatesResponse: "PubSubTopics:WEBSITE_UPDATES_RESPONSE"
};
